export default __webpack_public_path__ + "static/media/vchasnoAppIcon.4e7d8301.png";